import React, { Component } from "react"
import { Row, Col, FormGroup, Button, FormControl, InputGroup, Panel } from "react-bootstrap"
import { CSVLink } from 'react-csv'
import moment from 'moment'
import ContentWrapper from "../../components/layout/ContentWrapper"
import { blue, darkgray, style, red } from '../../utils/constants'
import { AthletesHeaders, EventsHeaders, SpotsFeesHeaders, FinanceHeaders } from './constants'
import { getHistory, getReports, getSeasonDates } from './api'

const searchTypes = {
  Athletes:'athletes',
  Events:'events',
  SpotsFees: 'spotsfees',
  Finance: 'finance'
}

const reportStyle = {
  border:`1px solid ${darkgray}`,
  borderRadius:'3px',
  color:'green'
}

class Reports extends Component 
{
  constructor(props)
  {
    super(props)

    this.state = {
      athletesList:[],
      eventsList:[],
      spotsFeesList: [],
      financeList: [],
      athletesLastRun:'', 
      eventsLastRun:'',  
      spotsFeesLastRun:'',
      viewLastRunDetails:false,
      reportType:searchTypes.Athletes,
      season:-1,
      makingReportRequest:false,
      makingHistoryRequest:false,
      seasonDates:[]
    }

    this.handleGenerateReport = this.handleGenerateReport.bind(this)
    this.handleViewLastRunDetails = this.handleViewLastRunDetails.bind(this)
    this.handleSearchTypeChange = this.handleSearchTypeChange.bind(this)
    this.handleSeasonChange = this.handleSeasonChange.bind(this)
    this.getAthletes = this.getAthletes.bind(this)
    this.getEvents = this.getEvents.bind(this)
    this.getSpotsFees = this.getSpotsFees.bind(this)
    this.getFinance = this.getFinance.bind(this)
    this.disableSearchButton = this.disableSearchButton.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
    this.seasonOptions = this.seasonOptions.bind(this)
    this.getSeasonDates = this.getSeasonDates.bind(this)
  }

  componentDidMount(){
    this.getSeasonDates()
  }

  handleSearchTypeChange(event) {
    const searchType = event.target.value
    this.setState({ reportType:searchType,viewLastRunDetails:false })
  }

  handleSeasonChange(event) {
    const seasonYear = event.target.value
    this.setState({ season:seasonYear,viewLastRunDetails:false })
  }

  handleGenerateReport() {
    const { reportType, season } = this.state
    this.setState({ viewLastRunDetails:false,makingReportRequest:true })
      switch (reportType){
        case searchTypes.Athletes: this.getAthletes(season); break;
        case searchTypes.Events: this.getEvents(season); break;
        case searchTypes.SpotsFees: this.getSpotsFees(season); break;
        case searchTypes.Finance: this.getFinance(season); break;
        default: break;      
    }
  }

  handleCancel(){
    this.setState({ viewLastRunDetails:false })
  }
  
  getAthletes(season) {
    const _this = this
    getReports(season, searchTypes.Athletes).then(function(response) {
      console.log('response ' + response.data)
      _this.setState({ makingReportRequest:false, athletesList:response.data })
      document.getElementById("csvLink").click()
    })
  }

  getEvents(season) {
    const _this = this
    getReports(season, searchTypes.Events).then(function(response) {
      _this.setState({ makingReportRequest:false, eventsList:response.data })
      document.getElementById("csvLink").click()
    })
  }

  getSpotsFees(season) {
    const _this = this
    getReports(season, searchTypes.SpotsFees).then(function(response) {
      _this.setState({  makingReportRequest:false, spotsFeesList:response.data })
      document.getElementById("csvLink").click()
    })
  }

  getFinance(season) {
    const _this = this
    getReports(season, searchTypes.Finance).then(function(response) {
      _this.setState({ makingReportRequest: false, financeList:response.data })
      document.getElementById("csvLink").click()
    })
  }

  handleViewLastRunDetails(){
    const _this = this
    this.setState ({
      makingHistoryRequest: true
    })
    getHistory().then(function(response) {
      const { athletes, events,spotsFees,finance }= response.data
      _this.setState({ makingHistoryRequest:false,athletesLastRun:athletes,eventsLastRun:events,spotsFeesLastRun:spotsFees, financeLastRun:finance,viewLastRunDetails:true  })
    })
  }

  getSeasonDates(){
    const _this = this
    getSeasonDates().then(function(response) {
      _this.setState({ seasonDates:response.data })
    })
  }

  disableSearchButton()
  {
   const { season } = this.state
   const noSeasonSpecified =  (season == -1)
   return noSeasonSpecified
  }

  seasonOptions()
    {
       const { seasonDates } = this.state
       const seasondatesarray = Object.values(seasonDates)
       const option = seasondatesarray.map((season) => {
                 return (<option key={season.id} value={season.id}>{season.description}</option>)
        })
       return option
    }

  render()
   {    
    const {  athletesLastRun, eventsLastRun, spotsFeesLastRun, financeLastRun, viewLastRunDetails, athletesList,
              eventsList, spotsFeesList, financeList, reportType,makingReportRequest, makingHistoryRequest } = this.state    
    const data = reportType === searchTypes.Athletes ? athletesList : reportType === searchTypes.Events ? eventsList : reportType === searchTypes.SpotsFees ? spotsFeesList : financeList
    const headers = reportType === searchTypes.Athletes ? AthletesHeaders : reportType === searchTypes.Events ? EventsHeaders : reportType === searchTypes.SpotsFees ? SpotsFeesHeaders : FinanceHeaders
    const filename = reportType === searchTypes.Athletes ? 'Athletes.csv' : reportType === searchTypes.Events ? 'Events.csv': reportType === searchTypes.SpotsFees ? 'SpotsFees.csv' : 'Finance.csv'
    const disableReport = this.disableSearchButton()
    const reportIcon = makingReportRequest ? 'fa fa-spinner fa-spin ':'fa fa-file-excel-o'
    const historyIcon = makingHistoryRequest ? 'fa fa-spinner fa-spin ':'fa fa-history'
    return (
      <ContentWrapper>
          <div className="content-heading">Season Reports</div>
          <form id="seasonreports" className="form-horizontal">
            <Row>
              <Col xs={12}>
                <div className="stacked-filter-panel" style={{ width:'100%' }}>
                  <FormGroup xs={12}>
                    <InputGroup>
                      <FormControl componentClass="select"
                        placeholder="All" onChange={this.handleSeasonChange}
                        style={{ minWidth:'150px',borderRadious:'0',maxWidth:'60px' }}>
                        <option value="-1">Select Season...</option>
                        { this.seasonOptions() }
                      </FormControl>                      
                      <FormControl  defaultValue={searchTypes.Athletes} componentClass="select" 
                        placeholder="All" onChange={this.handleSearchTypeChange}
                        style={{ minWidth:'150px',borderRadious:'0',maxWidth:'60px' }}>
                        <option value={searchTypes.Athletes}>Athletes</option>
                        <option value={searchTypes.Events}>Events</option>
                        <option value={searchTypes.SpotsFees}>Spots and Fees</option>
                        <option value={searchTypes.Finance}>Finance</option>
                      </FormControl>
                      <Button style={reportStyle} disabled={disableReport} onClick={this.handleGenerateReport}>
                        <i className={reportIcon} aria-hidden="true"  />&nbsp;&nbsp;Generate Report (.csv)
                      </Button>
                      <CSVLink
                            id="csvLink"
                            data={data} 
                            headers={ headers }
                            filename={ filename }
                            target='_blank'
                            className='hidden'
                            style={reportStyle}
                         />
                      <Button style={{ color:blue, minHeight:'27px' }} onClick={this.handleViewLastRunDetails}>
                        <i className={historyIcon} aria-hidden="true"  />&nbsp;&nbsp;View Last Run Details
                      </Button>
                    </InputGroup>
                  </FormGroup>
                </div>
                { viewLastRunDetails &&
                  <Panel style={{ maxWidth:'600px' }}>
                    <h5 style={{ color:blue }}><i className="fa fa-history" aria-hidden="true" />&nbsp;&nbsp;Reports last runs</h5>
                    <FormGroup>
                      <label className={style.lblattrs4}>Athlete Report:</label>
                      <Col lg={8 }>
                        <label className="form-control" style={{ borderWidth:'0px' }}>{moment(athletesLastRun).format('LLLL')} CST</label>
                      </Col>
                    </FormGroup>
                    <FormGroup>
                      <label className={style.lblattrs4}>Event Report:</label>
                      <Col sm={8 }>
                        <label className="form-control" style={{ borderWidth:'0px' }}>{moment(eventsLastRun).format('LLLL')} CST</label>
                      </Col>
                    </FormGroup>
                    <FormGroup>
                      <label className={style.lblattrs4}>Spots and Fees Report:</label>
                      <Col sm={8 }>
                      <label className="form-control" style={{ borderWidth:'0px' }}>{moment(spotsFeesLastRun).format('LLLL')} CST</label>
                      </Col>
                    </FormGroup>
                    <FormGroup>
                      <label className={style.lblattrs4}>Finance Report:</label>
                      <Col sm={8}>
                        <label className="form-control" style={{ borderWidth: '0px' }}>{moment(financeLastRun).format('LLLL')} CST</label>
                      </Col>
                    </FormGroup>
                    <FormGroup>
                      <Col sm={7 }>
                        <Button style={{ color:red, minHeight:'27px', float:'right' }} onClick={this.handleCancel}>
                            <i className='fa fa-remove' aria-hidden="true"  />&nbsp;&nbsp;Cancel
                        </Button>	
                      </Col>
                    </FormGroup>				
                  </Panel>
                }
              </Col>
            </Row>
          </form>
      </ContentWrapper>)
  }
}

export default Reports



// WEBPACK FOOTER //
// ./src/containers/reports/index.js